import { createTheme, ThemeProvider } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import qs from "query-string";
import { useLocation } from "react-router-dom";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApplicationRouter from "./AppRouter";
import { AlertProvider } from "./Context/KYCApplicationContext/AlertContext/AlertContext";
import { LoaderProvider } from "./Context/KYCApplicationContext/LoaderContext/LoaderContext";
import { SessionKeyEnum } from "./Enumeration/SessionKeyEnum";
import "./index.css";
import "./tab.css";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: "Segoe UI semibold",
      fontSize: 12,
    },
  });

  //read the location details
  const location = useLocation();
  const queryParam = qs?.parse(location.search);
  const queryToken = queryParam.kyc_st;
  const queryId = queryParam.id;

  //read the session details
  const sessionToken = sessionStorage.getItem(SessionKeyEnum.AppKey);
  const sessionQueryId = sessionStorage.getItem(SessionKeyEnum.Id);

  // If query token exists and not in session, store it in sessionStorage
  if (queryToken && !sessionToken) {
    const paramsArray = queryToken.split("/");
    sessionStorage.setItem(SessionKeyEnum.AppKey, paramsArray[0]);
  }

  // If query id exists and not in session, store it in sessionStorage
  if (queryId && !sessionQueryId) {
    sessionStorage.setItem(SessionKeyEnum.Id, queryId);
  }

  return (
    <ThemeProvider theme={theme}>
      <LoaderProvider>
        <AlertProvider>
          <ToastContainer
            icon={false}
            hideProgressBar={true}
            position="top-center"
            pauseOnHover
            autoClose={2000}
            transition={Zoom}
          />
          <ApplicationRouter></ApplicationRouter>
        </AlertProvider>
      </LoaderProvider>
    </ThemeProvider>
  );
}

export default App;
